<template>
  <div id="nesting-config-modal" class="modal" v-show="modalShown"  v-drag="{handle:'#modal-moving'}" style="position: fixed">
    <div class="modal-main">
      <div class="title-area" id="modal-moving">
        <h2>ネスティング設定</h2>
      </div>
      <div class="data-area">
        <div class="error_message">{{ errorMessage.text }}</div>
        <ul>
          <li class="sub-title"><span class="label">＜カット 条件設定＞</span></li>
          <li>
            <span class="label">ネスティングパターン選択</span>
            <div class="input">
              <span><label><input type="radio" v-model.number="nestMode" value="2">コスト優先</label></span>
              <span><label><input type="radio" v-model.number="nestMode" value="0">歩留まり優先</label></span>
              <span><label><input type="radio" v-model.number="nestMode" value="1">加工時間優先</label></span>
            </div>
          </li>
          <li>
            <span class="label">カット回数</span>
            <div class="input">
              <span><label><input type="radio" v-model.number="nestZCutFlag" value="0">２回</label></span>
              <span><label><input type="radio" v-model.number="nestZCutFlag" value="1">３回</label></span>
            </div>
          </li>
          <li>
            <span class="label">カット最小寸法</span>
            <div class="input">
              <span class="detail-label">幅</span><input type="number" v-model="nestCutMinW">㎜
              <span class="detail-label">高さ</span><input type="number" v-model="nestCutMinH">㎜
            </div>
          </li>
          <li class="sub-title"><span class="label">＜カット機 条件設定＞</span></li>
          <li>
            <span class="label radio-label">カット機条件</span>
            <div class="input">
              <div class="input-detail">
                <label>
                  <input type="radio" v-model.number="nestStackFlag" value="1">
                  リップカットとクロスカットが同じ機械
                </label>
              </div>
              <div class="input-detail">
                <label>
                  <input type="radio" v-model.number="nestStackFlag" value="0">
                  リップカットとクロスカットが別の機械
                </label>
              </div>
            </div>
          </li>
          <li>
            <span class="label">刃物厚さ</span>
            <div class="input">
              <input type="number" v-model="nestSawW">㎜
            </div>
          </li>
          <li>
            <span class="label">ランニングソー 逃げ爪量</span>
            <div class="input">
              <input type="number" v-model="nestNigetsume">㎜
            </div>
          </li>
          <li class="space-li">
          <div class="space-form">
            <span>後ろトリムY<br>原板上余白</span>
            <input type="number" v-model="nestConfSpaceUp">㎜
          </div>
          <div class="space-form middle">
            <div class="side">
              <span>後ろトリムX<br>原板左余白</span>
              <input type="number" v-model="nestConfSpaceLt">㎜
            </div>
            <div>
              <svg width=200 height=150>
                <rect
                  x=0
                  y=0
                  width=200
                  height=150
                  stroke="lightgray"
                  fill="lightgray"
                />
              </svg>
            </div>
            <div class="side">
              <span>前トリムX<br>原板右余白</span>
              <input type="number" v-model="nestConfSpaceRt">㎜
            </div>
          </div>
          <div class="space-form">
            <span>前トリムY<br>原板下余白</span>
            <input type="number" v-model="nestConfSpaceLo">㎜
          </div>
          <li>
            <span class="label">加工タクト</span>
            <div class="input">
              <span>刃物送り速度</span>
              <input type="number" v-model="nestCutlengthSec">秒/M
            </div>
          <li>
            <span class="label"/>
            <div class="input">
              <span>刃物昇降</span>
              <input type="number" v-model="nestCutcutSec">秒/1カット
            </div>
          </li>
          <li>
            <span class="label"/>
            <div class="input">
              <span>板セット</span>
              <input type="number" v-model="nestCutSetSec">秒/枚
              <div class="comment">＊カット機にカット前の板をセットする時間</div>
            </div>
          </li>
          <li>
            <span class="label"/>
            <div class="input">
              <span>板回転</span>
              <input type="number" v-model="nestCutturnSec">秒/枚
              <div class="comment">＊カット機で板を回転しセットする時間</div>
            </div>
          </li>
        </ul>
      </div>
      <p class="error_message" v-if="validateErrorMessages && Object.keys(validateErrorMessages).length > 0">{{ validateErrorMessages['nestMode'] }}</p>
      <p class="error_message" v-if="validateErrorMessages && Object.keys(validateErrorMessages).length > 0">{{ validateErrorMessages['nestZCutFlag'] }}</p>
      <p class="error_message" v-if="validateErrorMessages && Object.keys(validateErrorMessages).length > 0">{{ validateErrorMessages['nestCutMinW'] }}</p>
      <p class="error_message" v-if="validateErrorMessages && Object.keys(validateErrorMessages).length > 0">{{ validateErrorMessages['nestCutMinH'] }}</p>
      <p class="error_message" v-if="validateErrorMessages && Object.keys(validateErrorMessages).length > 0">{{ validateErrorMessages['nestStackFlag'] }}</p>
      <p class="error_message" v-if="validateErrorMessages && Object.keys(validateErrorMessages).length > 0">{{ validateErrorMessages['nestSawW'] }}</p>
      <p class="error_message" v-if="validateErrorMessages && Object.keys(validateErrorMessages).length > 0">{{ validateErrorMessages['nestNigetsume'] }}</p>
      <p class="error_message" v-if="validateErrorMessages && Object.keys(validateErrorMessages).length > 0">{{ validateErrorMessages['nestConfSpaceUp'] }}</p>
      <p class="error_message" v-if="validateErrorMessages && Object.keys(validateErrorMessages).length > 0">{{ validateErrorMessages['nestConfSpaceLo'] }}</p>
      <p class="error_message" v-if="validateErrorMessages && Object.keys(validateErrorMessages).length > 0">{{ validateErrorMessages['nestConfSpaceLt'] }}</p>
      <p class="error_message" v-if="validateErrorMessages && Object.keys(validateErrorMessages).length > 0">{{ validateErrorMessages['nestConfSpaceRt'] }}</p>
      <p class="error_message" v-if="validateErrorMessages && Object.keys(validateErrorMessages).length > 0">{{ validateErrorMessages['nestCutlengthSec'] }}</p>
      <p class="error_message" v-if="validateErrorMessages && Object.keys(validateErrorMessages).length > 0">{{ validateErrorMessages['nestCutcutSec'] }}</p>
      <p class="error_message" v-if="validateErrorMessages && Object.keys(validateErrorMessages).length > 0">{{ validateErrorMessages['nestCutSetSec'] }}</p>
      <p class="error_message" v-if="validateErrorMessages && Object.keys(validateErrorMessages).length > 0">{{ validateErrorMessages['nestCutturnSec'] }}</p>
      <div class="button-area">
      <button type="button" class="main_btn" @click="onUpdate">設定</button>
      <button type="button" class="main_btn" @click="onCancel">キャンセル</button>
      </div>
    </div>
  </div>
</template>
<script>
import axios from 'axios'
import * as Api from '../../utils/Api'
import * as AppUtil from '../../utils/App'
import {API_URL} from '../../constants/App'
export default {
  name: 'NestingConfigModal',
  props: {
    prevDialog: {
      type: Function,
      default: function () {}
    }
  },
  data () {
    return {
      /** モーダル開閉 */
      modalShown: false,
      /** 見積もり設定 */
      nestMode: null,
      nestZCutFlag: null,
      nestCutMinW: null,
      nestCutMinH: null,
      nestStackFlag: null,
      nestSawW: null,
      nestNigetsume: null,
      nestConfSpaceUp: null,
      nestConfSpaceLo: null,
      nestConfSpaceLt: null,
      nestConfSpaceRt: null,
      nestCutlengthSec: null,
      nestCutcutSec: null,
      nestCutSetSec: null,
      nestCutturnSec: null,
      errorMessage: { text: '' },
      validateErrorMessages: {}
    }
  },
  watch: {
    modalShown: function () {
      /** キャンバス内キーボード制御 */
      if (this.modalShown) {
        // this.$emit('onShowModal')
        document.addEventListener('keydown', this.onKeydown)
      } else {
        // this.$emit('onCloseModal')
        document.removeEventListener('keydown', this.onKeydown)
      }
    }
  },
  methods: {
    showModal: function () {
      this.modalShown = true
    },
    onCancel: function () {
      this.modalShown = false
      this.prevDialog()
    },
    onUpdate: function () {
      let payload = {
        nestMode: this.nestMode,
        nestZCutFlag: this.nestZCutFlag > 0,
        nestCutMinW: this.nestCutMinW,
        nestCutMinH: this.nestCutMinH,
        nestStackFlag: this.nestStackFlag > 0,
        nestSawW: this.nestSawW,
        nestNigetsume: this.nestNigetsume,
        nestConfSpaceUp: this.nestConfSpaceUp,
        nestConfSpaceLo: this.nestConfSpaceLo,
        nestConfSpaceLt: this.nestConfSpaceLt,
        nestConfSpaceRt: this.nestConfSpaceRt,
        nestCutlengthSec: this.nestCutlengthSec,
        nestCutcutSec: this.nestCutcutSec,
        nestCutSetSec: this.nestCutSetSec,
        nestCutturnSec: this.nestCutturnSec
      }
      console.log(payload)
      axios.post(API_URL.ADMIN + '/update-nesting-conf', payload
      ).then(response => {
        let modalData = {
          messages: ['変更しました'],
          onOk: () => {
            this.modalShown = false
            this.prevDialog()
          }
        }
        this.errorMessage = {}
        this.validateErrorMessages = {}
        AppUtil.showModal(modalData)
      }).catch(error => {
        this.validateErrorMessages = {}
        Api.handleError(error, this.errorMessage, this.validateErrorMessages)
      })
    },
    getNesting: function () {
      axios.get(API_URL.ADMIN + '/get-nesting-conf'
      ).then(response => {
        let data = response.data.data
        if (data) {
          this.nestMode = data.nestMode
          this.nestZCutFlag = data.nestZCutFlag ? 1 : 0
          this.nestCutMinW = data.nestCutMinW
          this.nestCutMinH = data.nestCutMinH
          this.nestStackFlag = data.nestStackFlag ? 1 : 0
          this.nestSawW = data.nestSawW
          this.nestNigetsume = data.nestNigetsume
          this.nestConfSpaceUp = data.nestConfSpaceUp
          this.nestConfSpaceLo = data.nestConfSpaceLo
          this.nestConfSpaceLt = data.nestConfSpaceLt
          this.nestConfSpaceRt = data.nestConfSpaceRt
          this.nestCutlengthSec = data.nestCutlengthSec
          this.nestCutcutSec = data.nestCutcutSec
          this.nestCutSetSec = data.nestCutSetSec
          this.nestCutturnSec = data.nestCutturnSec
        }
      }).catch(error => {
        Api.handleError(error)
      })
    }
  },
  created: function () {
    this.getNesting()
  }
}
</script>
<style lang="scss" scoped>
li{
  margin-bottom: 20px;
  div{
    // width: 175px;
    display: inline-block;
    padding: 10px;
    text-align: left;
  }
  .label{
    min-width: 190px;
    display: inline-block;
    text-align: left;
    font-weight: bold;
  }
  .radio-label{
    vertical-align: top;
  }
  .space-form{
    width: auto;
    padding: 0px;
    span{
      min-width: 100px;
      text-align: left;
      font-weight: bold;
      vertical-align: middle;
    }
  }
  .space-form.middle{
    width: 95%;
    display: inline-flex;
    padding: 0 26px;
    .side{
      padding-top: 60px;
    }
  }
  input[type="number"]{
    width: 60px;
  }
  .input{
    width: 370px;
    padding: 0px;
    min-height: 34px;
    span{
      width: 120px;
      display: inline-block;
      text-align: left;
    }
    .input-detail{
      width: 340px;
      padding: 0 0 10px 0;
    }
    .detail-label{
      width: auto;
      margin: 0 10px;
    }
    .comment{
      width: 340px;
      font-size: 13px;
      padding: 5px;
    }
  }
}
.space-li{
  margin: 60px 0 50px 0;
}
.sub-title{
  text-align: left;
  margin: 20px 0;
}
.data-area{
  padding: 20px;
  max-height: 660px;
  overflow: auto;
}
.modal-main{
  max-height: 100%;
  max-width: 740px;
}
.count_limit{
  font-size: 8px;
}
.error_message {
  margin-bottom: 10px;
}
</style>



// WEBPACK FOOTER //
// src/main/js/components/common/NestingConfigModal.vue